import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {TranslocoModule} from '@jsverse/transloco';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {MatLuxonDateModule} from '@angular/material-luxon-adapter';
import {MatDialogModule} from '@angular/material/dialog';

import {serviceInitializer} from '@astek/utils';

import {SharedModule} from '../shared/shared.module';
import {LanguageService} from './services/language/language.service';
import {ConfigService} from './services/config/config.service';
import {ThemeService} from './services/theme/theme.service';
import {LoggerService} from './services/logger/logger.service';
import {ErrorService} from './services/error/error.service';
import {NavigationService} from './services/navigation/navigation.service';
import {AuthGuardService} from './services/security/auth-guard.service';
import {RestApiService} from './services/http/rest-api.service';
import {AuthenticationService} from './services/authentication/authentication.service';
import {TokenStorageService} from './services/authentication/jwt/token-storage.service';
import {LoginRestApiService} from './services/authentication/http/login-rest-api.service';
import {AuthenticationInterceptor} from './services/authentication/http/authentication-interceptor';
import {CountryRestApiService} from './services/country/http/country-rest-api.service';
import {CountryService} from './services/country/country.service';
import {ToolbarComponent} from './components/toolbar/toolbar.component';
import {NotForClinicalUseComponent} from './components/not-for-clinical-use/not-for-clinical-use.component';
import {CacheInterceptor} from './services/cache/cache-interceptor';
import {StateService} from './services/state/state.service';
import {ResultsParserService} from './services/results-parser/results-parser.service';
import {PressureUnitKeyPipe} from './pipes/pressure-unit-key.pipe';
import {MeasureTypeKeyPipe} from './pipes/measure-type-key.pipe';
import {GenderKeyPipe} from './pipes/gender-key.pipe';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    NotForClinicalUseComponent,
    ConfirmDialogComponent,
    PressureUnitKeyPipe,
    MeasureTypeKeyPipe,
    GenderKeyPipe,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,

    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    MatDividerModule,
    MatLuxonDateModule,

    SharedModule,
  ],
  exports: [
    SharedModule,

    ToolbarComponent,
    NotForClinicalUseComponent,
    PressureUnitKeyPipe,
    MeasureTypeKeyPipe,
    GenderKeyPipe,
  ],
  providers: [
    LoggerService,
    serviceInitializer(LoggerService),
    ErrorService,
    ConfigService,
    serviceInitializer(ConfigService),
    AuthGuardService,
    serviceInitializer(AuthGuardService),
    LanguageService,
    serviceInitializer(LanguageService),
    ThemeService,
    serviceInitializer(ThemeService),
    NavigationService,
    serviceInitializer(NavigationService),
    RestApiService,
    AuthenticationService,
    serviceInitializer(AuthenticationService),
    TokenStorageService,
    LoginRestApiService,
    CountryRestApiService,
    CountryService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    StateService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true,
    },
    ResultsParserService,
  ],
})
export class CoreModule {
}
